import axios, { AxiosError } from 'axios';
import { localStorageItems } from 'setup/localStorage';

export const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_BASE_API_URL,
  headers: {
    'Accept-Language':
      localStorage.getItem(localStorageItems.appLanguage) || 'uk',
  },
});

axiosInstance.interceptors.request.use(function (config) {
  const token = localStorage.getItem(localStorageItems.accessToken);

  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  (res) => res,
  function (err: AxiosError) {
    const url = err.config?.url ?? '';
    // Clear the token only on a genuine 401 (unauthenticated / expired session). Exempt:
    //  - /auth/*  : login/register failures are not session expiry.
    //  - /admin/* : an admin-capability probe must NEVER log the user out. A non-admin — or a
    //    backend that answers 401 (instead of 403) for an authorization denial — hitting an admin
    //    endpoint is expected. Genuine expiry is still caught by the user's non-admin requests.
    //    Relying on the exact denial status (403 vs 401) here caused the admin-probe logout cascade.
    if (err.status === 401 && !url.includes('/auth/') && !url.includes('/admin/')) {
      console.error('Token missed or expired');
      localStorage.removeItem(localStorageItems.accessToken);
    }

    return Promise.reject(err);
  },
);
